const facingsData = [
	{ name: "North", code: "north", shortName: "North" },
	{ name: "North-East", code: "northEast", shortName: "N-E" },
	{ name: "East", code: "east", shortName: "East" },
	{ name: "South-East", code: "southEast", shortName: "S-E" },
	{ name: "South", code: "south", shortName: "South" },
	{ name: "South-West", code: "southWest", shortName: "S-W" },
	{ name: "West", code: "west", shortName: "West" },
	{ name: "North-West", code: "northWest", shortName: "N-W" },
];

export default facingsData;

// new facings
export const _facings = [
	{ code: "north", name: "North" },
	{ code: "east", name: "East" },
	{ code: "south", name: "South" },
	{ code: "west", name: "West" },
	{ code: "northEast", name: "North-East" },
	{ code: "northWest", name: "North-West" },
	{ code: "southEast", name: "South-East" },
	{ code: "southWest", name: "South-West" },
];
// List of facings with code in kebab-case (hyphen-separated)
export const facings = [
	{ name: "North", code: "north", shortName: "North" },
	{ name: "North-East", code: "north-east", shortName: "NE" },
	{ name: "East", code: "east", shortName: "East" },
	{ name: "South-East", code: "south-east", shortName: "SE" },
	{ name: "South", code: "south", shortName: "South" },
	{ name: "South-West", code: "south-west", shortName: "SW" },
	{ name: "West", code: "west", shortName: "West" },
	{ name: "North-West", code: "north-west", shortName: "NW" },
];
